export interface BoldMatchedTextParams {
  text: string | null;
  searchPhrase: string;
}
export const boldMatchedText = ({ text, searchPhrase }: BoldMatchedTextParams) => {
  if (!text) {
    return null;
  }
  if (!searchPhrase) {
    return text;
  }

  const escapedSearchPhrase = searchPhrase.replaceAll(/[$()*+.?[\\\]^{|}]/g, '\\$&').trim();
  const regExpPattern = new RegExp(escapedSearchPhrase, 'igu');
  const splitText = text.split(regExpPattern);
  const matches = text.match(regExpPattern);

  if (!matches) {
    return text;
  }

  return splitText.map((el, index) => {
    if (index > matches.length) {
      return el;
    }

    return (
      // eslint-disable-next-line react/no-array-index-key -- there is nothing unique here and this array is not mutable
      <span key={`${el}-${text}-${index}`}>
        {el}
        <strong>{matches[index]}</strong>
      </span>
    );
  });
};
